import axios from 'axios'

export const state = {
  companies: [],
}

export const getters = {
  getCityLedgerCompanies() {
    return state.companies
  },
}

export const mutations = {
  SET_CITY_LEDGER_COMPANIES(state, companies) {
    state.companies = companies
  },
}

export const actions = {
  createCLCompany({
    commit,
    state
  }, {
    companyDetails
  }) {
    return axios
      .post(`v1/cityLedger/company/`, companyDetails)
      .then(response => {
        return response
      })
  },
  getCLCompanies({
    commit
  }, groupId) {
    return axios.get(`v1/cityLedger/company/${groupId}`).then(response => {
      return response
    })
  },
  createCLAccount({
    commit,
    state
  }, {
    accountDetails
  }) {
    return axios
      .post(`v1/cityLedger/account/`, accountDetails)
      .then(response => {
        return response
      })
  },
  setCLCompanies({
    commit,
    state
  }, companies) {
    commit('SET_CITY_LEDGER_COMPANIES', companies)
  },
  getCLAccounts({
    commit
  }, groupId) {
    return axios.get(`v1/cityLedger/account/${groupId}`).then(response => {
      return response
    })
  },
  updateCLAccount({
    commit,
    state
  }, {
    accountDetails
  }) {
    return axios
      .put(`v1/cityLedger/account/`, accountDetails)
      .then(response => {
        return response
      })
  },
  updateCLCompany({
    commit,
    state
  }, {
    companyDetails
  }) {
    return axios
      .put(`v1/cityLedger/company/`, companyDetails)
      .then(response => {
        return response
      })
  },
  getCLAccountsByCompany({
    commit
  }, companyId) {
    return axios.get(`v1/cityLedger/accountsByCompany/${companyId}`).then(response => {
      return response
    })
  },
  settleCityLedgerPayments({
    commit
  }, transaction) {
    return axios.post(`v1/cityLedger/settlePayment/`, transaction)
      .then(response => {
        return response
      })
  },
  settleCityLedgerAccountPayments({
    commit
  }, transaction) {
    return axios.post(`v1/cityLedger/settleAccountPayment/`, transaction)
      .then(response => {
        return response
      })
  }
}
